import { render, staticRenderFns } from "./RecentFiles.vue?vue&type=template&id=4021f315&"
import script from "./RecentFiles.vue?vue&type=script&lang=js&"
export * from "./RecentFiles.vue?vue&type=script&lang=js&"
import style0 from "./RecentFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports